const t = {
  name: "Bluetooth",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.0002 0.0856934L18.1644 7.24991L13.4144 11.9999L18.1644 16.7499L11.0002 23.9141V14.4141L7.25015 18.1641L5.83594 16.7499L10.5859 11.9999L5.83594 7.24991L7.25015 5.83569L11.0002 9.58569V0.0856934ZM13.0002 14.4141V19.0857L15.3359 16.7499L13.0002 14.4141ZM13.0002 9.58569L15.3359 7.24991L13.0002 4.91412V9.58569Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Bluetooth
};
